<script>
  import Icon from "$lib/components/Icon.svelte";

  export let menuId;
  export let menuLabelId;
  export let label;
  export let isOpen;
  export let haspopup;
</script>

<!-- desktop -->
<div
  class="hidden lg:block font-bold lg:tracking-wide px-24 lg:px-0 pb-16"
  aria-labelledby={menuLabelId}
>
  {label}
</div>

<!-- mobile & tablet -->
<button
  class="lg:hidden w-full text-size-12 md:text-size-14 font-bold lg:tracking-wide px-24 outline-none group"
  aria-haspopup={haspopup}
  aria-expanded={isOpen}
  aria-controls={menuId}
  class:focus:border-b-2={!isOpen}
  class:focus:border-neutral-300={!isOpen}
  on:click
>
  <div class="flex justify-between items-center lg:px-24 py-16">
    <span>{label}</span>

    <span class="lg:hidden">
      {#if isOpen}
        <Icon type="chevron-up" />
      {:else}
        <Icon type="chevron-down" />
      {/if}
    </span>
  </div>
</button>
